<template>
  <b-card
    title="OSOS Analizi"
    class="border border-secondary"
  >
    <b-tabs>
      <b-tab active>
        <template #title>
          <feather-icon icon="ActivityIcon" />
          <span>Tüketim Analizi</span>
        </template>
        <div class="d-flex justify-content-end">
          <div class="demo-inline-spacing">
            <b-button
              variant="flat-success"
            >
              <feather-icon
                icon="RefreshCwIcon"
              />
              Yenile
            </b-button>
            <b-button variant="flat-danger">
              <feather-icon icon="ArrowUpRightIcon" />
              Excele Aktar
            </b-button>
          </div>
        </div><br>
        <b-table-lite
          hover
          :items="items"
        />
      </b-tab>
      <b-tab>
        <template #title>
          <feather-icon icon="BarChart2Icon" />
          <span>Yük Profili</span>
        </template>

        <span>Tab1</span>
      </b-tab>
      <b-tab enable>
        <template #title>
          <feather-icon icon="BatteryIcon" />
          <span>Endeks Verisi</span>
        </template>

        <span>tab2</span>
      </b-tab>
      <b-tab>
        <template #title>
          <feather-icon icon="BellIcon" />
          <span>Alarm</span>
        </template>

        <span>tab3</span>
      </b-tab>
    </b-tabs>
  </b-card>
</template>

<script>
import {
  BTableLite,
  BTabs, BTab, BCard, BButton,
} from 'bootstrap-vue'

export default {
  components: {

    BCard,
    BTabs,
    BTab,
    BButton,
    BTableLite,
  },
  data() {
    return {
      items: [
        {
          yıl: 0,
          ay: '',
          T0: '',
          T1: '',
          T2: '',
          T3: '',
          Endüktif: '',
          Kapasitif: '',

        },

      ],
    }
  },
}
</script>
